import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { RoleFormVM } from './role-form.viewmodel';
import { RoleFormPresentation } from './_role-form-presentation/role-new-form-presentation';
import { RolePermissionsFormPresentation } from './_role-form-presentation/role-permissions-form-presentation';
import { RolePermissionFormVM } from './role-permission-form.viewmodel';

interface IProps {
    fetchRolesList: () => void;
    closeEditRoleForm?: (roleId: string) => void;
    linkName?: string;
}

interface IPermissionProps {
    id: string;
    roleName: string;
}

const RoleFormContainer = withViewModel(
    RoleFormPresentation,
    (props: IProps) => {
        const { fetchRolesList, closeEditRoleForm, linkName } = props;
        const roleFormVM = new RoleFormVM(fetchRolesList, closeEditRoleForm);
        roleFormVM.setRole(linkName);
        return roleFormVM;
    },
    () => [],
);

const RoleFormPermissionsContainer = withViewModel(
    RolePermissionsFormPresentation,
    (props: IPermissionProps) => {
        const roleFormVM = new RolePermissionFormVM(props.id, props.roleName);
        roleFormVM.fetchRolePermissions();
        return roleFormVM;
    },
    () => [],
);

export { RoleFormContainer as RoleForm, RoleFormPermissionsContainer };
